import styled from 'styled-components';
import { Section } from 'styles/cards';
import colors from 'styles/colors';
import { fontWeight } from 'styles/common';

export const HighlightRow = styled.tr<{ isSelected: boolean }>`
  ${(props) => props.isSelected && `background-color: ${colors.selectorBackground};`};
`;

export const EllipsingContainer = styled.div`
  font-weight: ${fontWeight.bold};
`;

export const LinkContainer = styled.div`
  font-weight: ${fontWeight.semibold};
`;

export enum TagIntent {
  ACTIVE,
  WARNING,
  DANGER,
  DISABLED,
  UNKNOWN,
}

export const tagColors = {
  [TagIntent.ACTIVE]: {
    backgroundColor: colors.telematicsStatusConnectedBackground,
    color: colors.telematicsStatusConnectedText,
  },
  [TagIntent.DISABLED]: {
    backgroundColor: colors.gray85,
    color: colors.fleetSlateGray,
  },
  [TagIntent.DANGER]: {
    backgroundColor: colors.telematicsStatusDisconnectedBackground,
    color: colors.telematicsStatusDisconnectedText,
  },
  [TagIntent.WARNING]: {
    backgroundColor: colors.telematicsStatusUndetectedVinBackground,
    color: colors.telematicsStatusUndetectedVinText,
  },
  [TagIntent.UNKNOWN]: {
    backgroundColor: colors.telematicsStatusReadyToConnectBackground,
    color: colors.telematicsStatusReadyToConnectText,
  },
} as const;

export const TagContainer = styled.div<{ intent: TagIntent }>`
  display: flex;
  width: fit-content;
  padding: 2px 8px 2px 4px;
  border-radius: 3px;

  background-color: ${(props) => tagColors[props.intent].backgroundColor};
  color: ${(props) => tagColors[props.intent].color};
`;

export const TagIconContainer = styled.div`
  padding-right: 4px;
`;

export const TagTextContainer = styled.div`
  display: flex;
  font-weight: ${fontWeight.semibold};
`;

export const TelematicsSection = styled(Section)`
  max-height: 50vh;
`;
